import HttpCliente from '../HttpCliente';

/**
 * GET method - Obtiene la lista de Series
 * @param {Function} setSeries función para establecer la lista de Series
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getShowsEstreno = (setSeries, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/estrenos", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setSeries(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

/*
curl -X 'GET' \
  'https://localhost:7176/api/VideoShows/7048A1D0-EFB5-4EA5-384E-08DD82D358EF' \
  -H 'accept: text/plain'
*/

/**
 * GET method - Obtiene informacion de un VideoShow por ID
 * @param {string} id - ID del VideoShow
 * 
 * @param {Function} setSeries función para establecer la lista de Series
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */

export const getVideoShowById = (id, setCapitulo, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/VideoShows/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setCapitulo(response.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};


/**
 * GET method - Obtiene la lista de Series
 * @param {Function} setSeries función para establecer la lista de Series
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getShowsDestacados = (setShows, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/destacados", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setShows(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};


export const getTagsStandup = (setShows, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/tagstandup", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setShows(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

export const getShowsHumorNegro= (setShows, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/tagHumorNegro", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setShows(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};


export const getHumorAbsurdo= (setShows, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/tagHumorAbsurdo", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setShows(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

export const getTopMasVistos= (setShows, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/VideoShows/topmasvistos", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setShows(response.data); // Establece la lista de Series en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

/**
 * GET method - Obtiene una lista paginada de VideoShows
 * @param {Function} setVideoShows - Función para establecer la lista de VideoShows
 * @param {Function} setError - Función para establecer el estado de error
 * @param {number} pageNumber - Número de página actual (por defecto: 1)
 * @param {number} pageSize - Cantidad de elementos por página (por defecto: 10)
 * @param {string} searchTerm - Término de búsqueda (opcional)
 * @param {string} token - Token de autenticación
 * @return {Promise} Promesa de obtención
 */
export const getVideoShowsPaginados = (setVideoShows, setError, pageNumber = 1, pageSize = 10, searchTerm = "", token) => {
    return new Promise((resolve, reject) => {
        // Construir la URL con parámetros de consulta
        let url = `/VideoShows/paged?pageNumber=${pageNumber}&pageSize=${pageSize}`;
        
        // Agregar término de búsqueda si existe
        if (searchTerm && searchTerm.trim() !== "") {
            url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
        }
        
        HttpCliente.get(url, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setVideoShows(response.data); // Establece la lista paginada de VideoShows en el estado
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                // Manejar otros códigos de estado
                setError(response.data.message); // Establecer el estado de Error con el mensaje
                reject(response.data.message); // Rechazar la promesa con el mensaje de error
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message); // Establecer el estado de Error con el mensaje de error
                reject(error.response.data.message); // Rechazar la promesa con el mensaje de error
            } else {
                setError("Error de conexión"); // Establecer el estado de Error con un mensaje genérico
                reject("Error de conexión"); // Rechazar la promesa con un mensaje genérico
            }
        });
    });
};

/**
 * POST method - Crea un nuevo VideoShow
 * @param {Object|FormData} videoShowData - Datos del nuevo VideoShow (puede ser JSON o FormData)
 * @param {Function} setError - Función para establecer el estado de error
 * @param {string} token - Token de autenticación
 * @return {Promise} Promesa de creación
 */
export const createVideoShow = (videoShowData, setError, token) => {
    //console.log("Datos enviados para crear VideoShow:", videoShowData);
    return new Promise((resolve, reject) => {
        // Detectar si son datos con archivos (FormData) o datos JSON
        const isFormData = videoShowData instanceof FormData;
        
        // Configurar headers según el tipo de datos
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        };

        // Solo agregar Content-Type para JSON, FormData lo maneja automáticamente
        if (!isFormData) {
            config.headers['Content-Type'] = 'application/json';
        }

        HttpCliente.post("/VideoShows", videoShowData, config)
        .then(response => {
            if (response.status === 201 || response.status === 200) {
                resolve(response.data); // Resuelve la promesa con la respuesta del servidor
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al crear el video";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * PUT method - Actualiza un VideoShow existente
 * @param {string} id - ID del VideoShow a actualizar
 * @param {Object} videoShowData - Datos actualizados del VideoShow
 * @param {Function} setError - Función para establecer el estado de error
 * @param {string} token - Token de autenticación
 * @return {Promise} Promesa de actualización
 */
export const updateVideoShow = (id, videoShowData, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/VideoShows/${id}`, videoShowData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al actualizar el video";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * DELETE method - Elimina un VideoShow
 * @param {string} id - ID del VideoShow a eliminar
 * @param {Function} setError - Función para establecer el estado de error
 * @param {string} token - Token de autenticación
 * @return {Promise} Promesa de eliminación
 */
export const deleteVideoShow = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.delete(`/VideoShows/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 204 || response.status === 200) {
                resolve(true);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al eliminar el video";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene todos los comediantes disponibles
 * @param {Function} setComediantes - Función para establecer la lista de comediantes
 * @param {Function} setError - Función para establecer el estado de error
 * @param {string} token - Token de autenticación
 * @return {Promise} Promesa de obtención
 */
export const getComediantes = (setComediantes, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Comediantes", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setComediantes(response.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al obtener comediantes";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene todos los tags disponibles
 * @param {Function} setTags - Función para establecer la lista de tags
 * @param {Function} setError - Función para establecer el estado de error
 * @param {string} token - Token de autenticación
 * @return {Promise} Promesa de obtención
 */
export const getTags = (setTags, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Tags", {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setTags(response.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al obtener tags";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};